import React, { useEffect, useState } from 'react';
import Picker from 'react-mobile-picker-scroll';

interface CustomDateTimePickerProps {
    dateValue?: Date;
    timeValue?: Date;
    minDate?: Date;
    onChange?: (dateTime: string) => void;
}

const pad = (num: number) => num.toString().padStart(2, '0');

const CustomDateTimePicker: React.FC<CustomDateTimePickerProps> = ({
    dateValue,
    timeValue,
    minDate,
    onChange,
}) => {
    const [showPicker, setShowPicker] = useState<boolean>(false)
    const [shouldClose, setShouldClose] = useState<boolean>(false);
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const defaultTime = new Date();
    defaultTime.setHours(9, 0, 0, 0); // 09:00

    const [date, setDate] = useState(tomorrow);
    const [time, setTime] = useState(defaultTime);
    const [selectedDate, setSelectedDate] = useState({
        year: String(tomorrow.getFullYear()),
        month: pad(tomorrow.getMonth() + 1),
        day: pad(tomorrow.getDate()),
    });

    const [selectedTime, setSelectedTime] = useState({
        hour: timeValue ? pad(timeValue.getHours()) : '09',
        minute: timeValue ? pad(timeValue.getMinutes()) : '00',
    });

    const now = new Date();

    const years = Array.from({ length: 10 }, (_, i) => String(now.getFullYear() + i));
    const months = Array.from({ length: 12 }, (_, i) => pad(i + 1));
    const days = Array.from({ length: 31 }, (_, i) => pad(i + 1));
    const hours = Array.from({ length: 24 }, (_, i) => pad(i));
    const minutes = Array.from({ length: 60 }, (_, i) => pad(i));

    const handleDateChange = (name: string, value: string) => {
        setSelectedDate((prev) => ({ ...prev, [name]: value }));
    };

    const handleTimeChange = (name: string, value: string) => {
        setSelectedTime((prev) => ({ ...prev, [name]: value }));
    };

    const handleConfirm = () => {
        const date = new Date(
            Number(selectedDate.year),
            Number(selectedDate.month) - 1,
            Number(selectedDate.day)
        );

        const time = new Date();
        time.setHours(Number(selectedTime.hour));
        time.setMinutes(Number(selectedTime.minute));
        time.setSeconds(0);
        time.setMilliseconds(0);
        console.log('Selected Date:', date);
        console.log('Selected Time:', time);
        console.log('Min Date:', minDate);
        const minDateMidnight = new Date(time.getFullYear(), time.getMonth(), time.getDate());
        console.log('result', date >= minDateMidnight);

        if (date >= minDateMidnight) {
            setDate(date);
            setTime(time);
            setShouldClose(true);
            if (onChange) {
                const combined = new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate(),
                    time.getHours(),
                    time.getMinutes(),
                    0
                );
                onChange(combined.toISOString());
            }
        } else {
            //   alert('ไม่สามารถเลือกวันที่ย้อนหลังได้');
        }
    };

    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow;
        if (showPicker) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = originalStyle; // กรณีปิด modal ให้คืนค่าทันที
        }

        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, [showPicker]);

    useEffect(() => {
        console.log('showPicker changed:', showPicker)
    }, [showPicker])

    useEffect(() => {
        if (shouldClose) {
            setShowPicker(false);
            setShouldClose(false); // reset
        }
    }, [shouldClose]);

    return (
        <>
            <input
                type="text"
                readOnly
                value={`${date.getFullYear()}-${(date.getMonth() + 1)
                    .toString()
                    .padStart(2, "0")}-${date
                        .getDate()
                        .toString()
                        .padStart(2, "0")} ${time.getHours().toString().padStart(2, "0")}:${time
                            .getMinutes()
                            .toString()
                            .padStart(2, "0")}`}
                onClick={() => setShowPicker(true)}
                placeholder="เลือกวันที่และเวลา"
                className="input input-bordered cursor-pointer"
            />
            {
                showPicker && (
                    <div className="fixed inset-0 z-7500 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm" style={{ zIndex: 7500 }}>
                        <div className="bg-white rounded-xl p-4 w-[320px]">
                            <div className="flex justify-between">
                                <button onClick={() => setShouldClose(true)} className="text-blue-500">ยกเลิก</button>
                                <button onClick={handleConfirm} className="text-blue-500 font-semibold">ตกลง</button>
                            </div>
                            <div className="mt-4">
                                <div className="mb-4">
                                    <div className="text-sm text-gray-600 mb-1">วันที่</div>
                                    <Picker
                                        optionGroups={{
                                            year: years,
                                            month: months,
                                            day: days,
                                        }}
                                        valueGroups={selectedDate}
                                        onChange={handleDateChange}
                                        height={144}
                                        itemHeight={36}
                                    />
                                </div>
                                <div>
                                    <div className="text-sm text-gray-600 mb-1">เวลา</div>
                                    <Picker
                                        optionGroups={{
                                            hour: hours,
                                            minute: minutes,
                                        }}
                                        valueGroups={selectedTime}
                                        onChange={handleTimeChange}
                                        height={144}
                                        itemHeight={36}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

export default CustomDateTimePicker;
